import { MeetCourseType } from "types/code-generator";

export const meetEligibility = {
  "Yards only": "YO",
  "SCM only": "SO",
  "LCM only": "LO",
  "Yards then SCM": "YS",
  "Yards then LCM": "YL",
  "Yards then SCM then LCM": "YSL",
  "Yards then LCM then SCM": "YLS",
  "SCM then Yards": "SY",
  "SCM then LCM": "SL",
  "SCM then Yards then LCM": "SYL",
  "SCM then LCM then Yards": "SLY",
  "LCM then Yards": "LY",
  "LCM then SCM": "LS",
  "LCM then Yards then SCM": "LYS",
  "LCM then SCM then Yards": "LSY",
};

export const meetEligibilityMap = {
  YO: [MeetCourseType.Yards],
  SO: [MeetCourseType.SCM],
  LO: [MeetCourseType.LCM],
  YS: [MeetCourseType.Yards, MeetCourseType.SCM],
  YL: [MeetCourseType.Yards, MeetCourseType.LCM],
  YSL: [MeetCourseType.Yards, MeetCourseType.SCM, MeetCourseType.LCM],
  YLS: [MeetCourseType.Yards, MeetCourseType.LCM, MeetCourseType.SCM],
  SY: [MeetCourseType.SCM, MeetCourseType.Yards],
  SL: [MeetCourseType.SCM, MeetCourseType.LCM],
  SYL: [MeetCourseType.SCM, MeetCourseType.Yards, MeetCourseType.LCM],
  SLY: [MeetCourseType.SCM, MeetCourseType.LCM, MeetCourseType.Yards],
  LY: [MeetCourseType.LCM, MeetCourseType.Yards],
  LS: [MeetCourseType.LCM, MeetCourseType.SCM],
  LYS: [MeetCourseType.LCM, MeetCourseType.Yards, MeetCourseType.SCM],
  LSY: [MeetCourseType.LCM, MeetCourseType.SCM, MeetCourseType.Yards],
};
